import React from 'react';
import { Box, Container, Heading, Text, VStack, Grid, GridItem, Image } from '@chakra-ui/react';
import AproposBg from '../utils/images/image_apropos.png';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const APropos = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="white">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        {/* Section 1 – iOS light background */}
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="transparent"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={{ base: 10, lg: 16 }} alignItems="center">
              <GridItem>
                <VStack align="start" spacing={5} textAlign="left">
                  <Heading as="h2" size="xl" fontWeight={800} color="gray.900">
                    🎯 Notre mission : faciliter vos démarches de séjour en France
                  </Heading>
                  <VStack spacing={4} maxW="700px">
                    <Text color="gray.700">
                      Obtenir ou renouveler un titre de séjour en France n’est jamais simple. Les démarches administratives en ligne, que ce soit via l’ANEF ou d’autres plateformes dématérialisées, sont souvent complexes, sources d’erreurs et de délais inutiles.
                    </Text>
                    <Text color="gray.700">
                      Chez Rester en France, notre rôle est clair : vous accompagner pas à pas, de la constitution de votre dossier jusqu’au dépôt officiel de votre demande, afin de vous garantir une procédure rapide, sécurisée et transparente.
                    </Text>
                    <Text color="gray.700">
                      Nous mettons à votre disposition une solution clé en main, pensée pour les étrangers en France qui souhaitent :
                    </Text>
                    <VStack align="start" spacing={2} color="gray.700">
                      <Text>• déposer une première demande de titre de séjour,</Text>
                      <Text>• renouveler leur carte de séjour,</Text>
                      <Text>• demander un visa,</Text>
                      <Text>• ou encore contester une OQTF ou une décision administrative.</Text>
                    </VStack>
                  </VStack>
                </VStack>
              </GridItem>
              <GridItem>
                <Image
                  src={AproposBg}
                  alt="Rester en France"
                  borderRadius="3xl"
                  boxShadow="0 25px 80px rgba(0,0,0,0.15)"
                  w="100%"
                  h={{ base: '260px', md: '360px', lg: '480px' }}
                  objectFit="cover"
                />
              </GridItem>
            </Grid>
          </Container>
        </Box>

        {/* Section 2 – iOS vibrant gradient */}
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="transparent"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Box
              borderRadius="3xl"
              overflow="hidden"
              bg="white"
              border="1px solid"
              borderColor="gray.100"
              boxShadow="0 12px 40px rgba(0,0,0,0.08)"
              p={{ base: 6, lg: 8 }}
            >
              <VStack spacing={6} align="start" textAlign="left" color="gray.800" w="full">
                <Box w="64px" h="6px" bg="linear-gradient(90deg, #ffffff 0%, rgba(255,255,255,0.6) 50%, #ffffff 100%)" borderRadius="full" />
                <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">⭐ Pourquoi faire appel à nous ?</Heading>
                <VStack spacing={4} maxW="900px" color="gray.700" align="start" w="full">
                  <Text textAlign="left">1. <b>Réactivité</b> – Vous êtes rappelé sous 24 heures ouvrées.</Text>
                  <Text textAlign="left">2. <b>Rapidité</b> – Dès que votre dossier est validé, il est déposé sous 48 heures.</Text>
                  <Text textAlign="left">3. <b>Expertise</b> – Nos partenaires spécialistes en droit des étrangers ont plusieurs années d’expérience.</Text>
                  <Text textAlign="left">4. <b>Tarifs clairs et sans surprise</b> – Prix forfaitaires, fixés à l’avance, sans frais cachés.</Text>
                  <Text textAlign="left">5. <b>Transparence totale</b> – Vous accédez à vos documents et à votre attestation de dépôt sur une plateforme sécurisée, disponible 24/7 pendant 2 ans.</Text>
                </VStack>
                <Text fontWeight={700} color="gray.800" textAlign="left">
                  👉 Avec Rester en France, vous bénéficiez d’un service clair, rapide et sécurisé pour mener à bien vos démarches administratives, sans stress et sans mauvaises surprises.
                </Text>
              </VStack>
            </Box>
          </Container>
        </Box>

        {/* Section Tarifs */}
        <Container maxW="1200px" px={5} py={{ base: 10, lg: 14 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">💶 Nos tarifs</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• Première demande de titre de séjour : 685 € TTC</Text>
                <Text>• Renouvellement de titre de séjour : 585 € TTC</Text>
                <Text>• Visa, OQTF, contestation administrative : tarif sur devis après consultation</Text>
              </VStack>
            </VStack>
          </Box>
        </Container>

        {/* Section Process */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">⚙️ Comment ça marche ?</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>1. Remplissez notre formulaire en ligne en quelques minutes (nom, nationalité, date d’entrée en France, type de demande).</Text>
                <Text>2. Nos experts analysent votre dossier et vous contactent sous 24 heures.</Text>
                <Text>3. Vous choisissez votre mode de traitement :</Text>
                <VStack align="start" pl={4} spacing={1} color="gray.700">
                  <Text>• Accompagnement standard : rappel sous 24h, dépôt sous 48h.</Text>
                  <Text>• Option urgente : paiement immédiat en ligne, rappel sous 8h ouvrées, dépôt sans délai.</Text>
                </VStack>
                <Text>4. Vous recevez votre attestation officielle de dépôt, utilisable auprès de la préfecture et des administrations françaises.</Text>
              </VStack>
            </VStack>
          </Box>
        </Container>

        {/* Section Publics */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">🌍 Un service pensé pour tous les étrangers en France</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• Ressortissants européens (UE/EEE/Suisse)</Text>
                <Text>• Ressortissants algériens (accord bilatéral)</Text>
                <Text>• Ressortissants de pays tiers</Text>
                <Text>• Étudiants, salariés, entrepreneurs, familles, demandeurs de soins, conjoints de Français, etc.</Text>
              </VStack>
              <Text color="gray.700">Peu importe votre situation, notre mission est de vous offrir un accompagnement fiable et rapide, en toute sécurité juridique.</Text>
            </VStack>
          </Box>
        </Container>

        {/* Section Engagement */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">🤝 Notre engagement</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• Un accompagnement humain : vous n’êtes jamais seul face à l’administration.</Text>
                <Text>• Une sécurité maximale : vos données et documents sont protégés et traités en toute confidentialité.</Text>
                <Text>• Un service 100% en ligne : accessible sur ordinateur, tablette ou smartphone, en France comme à l’étranger.</Text>
                <Text>• Une solution efficace : moins de stress, moins d’erreurs, plus de rapidité.</Text>
              </VStack>
            </VStack>
          </Box>
        </Container>

        {/* Section Contact CTA */}
        <Container maxW="1200px" px={5} py={{ base: 6, lg: 10 }}>
          <Box
            bg="linear-gradient(90deg, #0053b3, #ef3340)"
            borderRadius="2xl"
            p={{ base: 8, lg: 12 }}
            color="white"
            textAlign="center"
          >
            <VStack spacing={4}>
              <Heading size="md" fontWeight={800} textAlign="center">✉️ Contactez-nous dès aujourd’hui</Heading>
              <Text>Vous souhaitez démarrer votre démarche ? ➡️ Remplissez directement notre formulaire sécurisé et recevez un rappel rapide de notre équipe.</Text>
              <Text>📧 Envoyez-nous un message (réponse garantie, pas de numéro de téléphone direct pour assurer un suivi fluide et confidentiel).</Text>
            </VStack>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default APropos;


